import {Component, OnInit, ElementRef, ViewChild,} from '@angular/core';
import {slideToLeft} from "../../../animations/router.animations";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ExistingUserService} from "../../../service/sell/existingUser.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PopupComponent} from "../../../shared/popup/popup.component";
import {formatNumber,formatCurrency} from "@angular/common";
import {LoaderService} from "../../../service/loader.service";
import {PrizesService} from "../../../service/prizes/prizes.service";
import {PROJECT_CONFIG, PROJECT_MESSAGES} from "../../../config/project";
import {StylingService} from "../../../service/styling.service";
import {ScrollToService} from "../../../service/scrollTo.service";
import {KioskAccessorService} from "../../../service/kiosk/kiosk-accessor.service";
import {KeyboardService} from "../../../service/keyboard.service";
import {CRYPTO_SETTINGS} from "../../../config/crypto_settings";
import {POPUP_TYPES, showPopupFormType} from "../../investments/investments-popup-form/investments-popup-form.config";

@Component({
    selector: 'app-prizes-cashapp',
    templateUrl: './prizes-cashapp.component.html',
    styleUrls: ['./prizes-cashapp.component.scss'],
    animations: [slideToLeft],
    host: {'[@slideToLeft]': ''}
})
export class PrizesCashappComponent implements OnInit {
    cashappForm: FormGroup;
    availableBalance = 0;
    moreThenAvailable = false;

    constructor(private formBuilder: FormBuilder,
                private route: ActivatedRoute,
                private eRef: ElementRef,
                private loaderService: LoaderService,
                private popupComponent: PopupComponent,
                private prizesService: PrizesService,
                private router: Router,
                private stylingService: StylingService,
                private scrollToService: ScrollToService,
                private kioskAccessorService: KioskAccessorService,
                private keyboardService: KeyboardService,
                private existingUserService: ExistingUserService) {
        this.kioskAccessorService.paymentComplete.subscribe((val) => {
            if (val !== null) {
                this.getBalance();
            }
        });
    }

    ngOnInit() {
        this.getBalance();

        this.cashappForm = this.formBuilder.group({
            amount: [null, Validators.required],
            handle: [null, Validators.required],
        });
    }

    getBalance(){
        this.prizesService.cashAppBalance().subscribe(data => {
            this.setRequestResult(data);
        }, (error) => {
            this.loaderService.hideAndShowTryAgain();
        }, () => {
            this.loaderService.hide();
        });
    }

    setRequestResult(data) {
        try {
            const availableBalance = Number.parseFloat(data.availableBalance);

            if (data && (availableBalance || availableBalance === 0)) {
                this.setBalance(availableBalance);
            }

            this.setCashappHandle(data);

            if (data.status === false) {
                this.popupComponent.showPopupError({text: data.message});
            } else if (data.status === undefined) {
                this.loaderService.hideAndShowTryAgain();
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }
    }

    setCashappHandle(data) {
        if (data && data.cashappHandle) {
            const value = data.cashappHandle && String(data.cashappHandle).trim() ? data.cashappHandle : null;
            this.cashappForm.controls.handle.setValue(value);
        } else {
            this.cashappForm.controls.handle.setValue(null);
        }
    }

    setBalance(balance: number) {
        const balanceNumber = balance;
        if (balanceNumber || balanceNumber === 0) {
            this.availableBalance = balanceNumber;
        }
    }

    getActiveColor() {
        return this.stylingService.getPageColor();
    }

    onSubmit() {
        const amount = this.getInputValue('amount');
        const handle = this.getInputValue('handle');

        if (amount && handle) {
            this.prizesService.redeemViaCashApp(amount, handle).subscribe(data => {
                this.submitResult(data);
            }, (error) => {
                this.loaderService.hideAndShowTryAgain();
            }, () => {
                this.loaderService.hide();
            });
        } else {
            this.popupComponent.showPopupError({text: 'Please fill all form fields'});
        }
    }

    submitResult(data) {
        try {
            if (data.status === true) {
                this.popupComponent.showPopupSuccess({text: data.message});
                this.cashappForm.reset();
                this.moreThenAvailable = false;
                this.getBalance();
            } else if (data.status === false) {
                this.popupComponent.showPopupError({text: data.message});
            } else if (data.status === undefined) {
                this.loaderService.hideAndShowTryAgain();
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }

    }

    getInputValue(field) {
        if (this.cashappForm.controls[field]) {
            return this.cashappForm.controls[field].value;
        }
    }

    onAmountInput() {
        const entered = +this.cashappForm.controls.amount.value;

        if (entered === 0) {
            this.cashappForm.controls.amount.setValue(String(null));
        }

        if ((this.availableBalance || this.availableBalance === 0) && (this.availableBalance < entered)) {
            if (this.availableBalance === 0) {
                this.cashappForm.controls.amount.setValue(String(null));
            } else {
                this.cashappForm.controls.amount.setValue(String(this.availableBalance));
            }
            this.moreThenAvailable = true;
        } else {
            this.moreThenAvailable = false;
        }
    }
}

